export default {"src":"/_next/static/media/indexing.844b775b.svg","height":501,"width":1405,"blurWidth":0,"blurHeight":0};